module.exports = __webpack_public_path__ + "static/Face-Matt.caf62523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Matt.jpg
// module id = 488
// module chunks = 144251824217401